import {
    GET_TEAM_ALCOM_SCORES,
    GET_TEAM_ALCOM_SCORES_SUCCESS,
    GET_TEAM_ALCOM_SCORES_FAIL,
    GET_SERVICE_ALCOM_SCORES,
    GET_SERVICE_ALCOM_SCORES_SUCCESS,
    GET_SERVICE_ALCOM_SCORES_FAIL,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS,
    GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL,
    GET_MTTA_MTTR_METRICS,
    GET_MTTA_MTTR_METRICS_SUCCESS,
    GET_MTTA_MTTR_METRICS_FAIL,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS,
    GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL
} from "./actionTypes";

export const getTeamAlcomScores = (data) => ({
    type: GET_TEAM_ALCOM_SCORES,
    payload: data,
});

export const getTeamAlcomScoresSuccess = (data) => ({
    type: GET_TEAM_ALCOM_SCORES_SUCCESS,
    payload: data,
});

export const getTeamAlcomScoresFail = (error) => ({
    type: GET_TEAM_ALCOM_SCORES_FAIL,
    payload: error,
});

export const getServiceAlcomScores = (data) => ({
    type: GET_SERVICE_ALCOM_SCORES,
    payload: data,
});

export const getServiceAlcomScoresSuccess = (data) => ({
    type: GET_SERVICE_ALCOM_SCORES_SUCCESS,
    payload: data,
});

export const getServiceAlcomScoresFail = (error) => ({
    type: GET_SERVICE_ALCOM_SCORES_FAIL,
    payload: error,
});

export const getUnmappedResourceAlcomScores = () => ({
    type: GET_UNMAPPED_RESOURCE_ALCOM_SCORES,
});

export const getUnmappedResourceAlcomScoresSuccess = (data) => ({
    type: GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS,
    payload: data,
});

export const getUnmappedResourceAlcomScoresFail = (error) => ({
    type: GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL,
    payload: error,
});

export const getMTTAMTTRMetrics = (data) => ({
    type: GET_MTTA_MTTR_METRICS,
    payload: data
});

export const getMTTAMTTRMetricsSuccess = mttaMttrMetrics => ({
    type: GET_MTTA_MTTR_METRICS_SUCCESS,
    payload: mttaMttrMetrics,
})

export const getMTTAMTTRMetricsFail = error => ({
    type: GET_MTTA_MTTR_METRICS_FAIL,
    payload: error,
})

export const getMTTAMTTRMetricsForTeams = (data) => ({
    type: GET_MTTA_MTTR_METRICS_FOR_TEAMS,
    payload: data
})

export const getMTTAMTTRMetricsForTeamsSuccess = mttaMttrMetrics => ({
    type: GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS,
    payload: mttaMttrMetrics
})

export const getMTTAMTTRMetricsForTeamsFail = error => ({
    type: GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL,
    payload: error
})
